import * as types from './MutationTypes'
import {
  GiftService,
  GiftBoxEvents
} from '../services'

const state = {
  sendingGift: null,
  receivingGift: null,
  getGiftSucceeded: false,
  sendGiftSucceeded: null,
  receiveGiftSucceeded: null,
  sendMailSucceeded: false,
  cancelGiftSucceeded: false,
  inProgress: false,
  notificationMessage: ''
}

const mutations = {
  [types.GET_GIFT] (state, payload) {
    state.sendingGift = payload.gift
    state.receivingGift = payload.gift
    state.getGiftSucceeded = payload.succeeded
  },

  [types.RECEIVE_GIFT] (state, payload) {
    state.receiveGiftSucceeded = payload.succeeded
    state.notificationMessage = payload.notificationMessage
  },

  [types.SEND_GIFT] (state, payload) {
    state.sendingGift = payload.gift
    state.sendGiftSucceeded = payload.succeeded
    state.notificationMessage = payload.notificationMessage
  },

  [types.CANCEL_GIFT] (state, payload) {
    state.cancelGiftSucceeded = payload.succeeded
  },

  [types.SEND_MAIL] (state, payload) {
    state.sendMailSucceeded = payload.succeeded
  },

  [types.IN_PROGRESS] (state, payload) {
    state.inProgress = payload.inProgress
  }
}

const actions = {
  getGift ({ commit }, payload) {
    GiftService
      .get(payload.uuid)
      .then(gift => commit(types.GET_GIFT, { gift: gift, succeeded: true }))
      .catch(error => commit(types.GET_GIFT, { gift: null, succeeded: false }))
  },

  receiveGift ({ commit }, payload) {
    commit(types.IN_PROGRESS, { inProgress: true })

    GiftService
      .receive(payload.gift)
      .then(gift => {
        commit(types.RECEIVE_GIFT, { succeeded: true })
        commit(types.IN_PROGRESS, { inProgress: false })
      })
      .catch(error => {
        var notificationMessage = '受け取りに失敗しました'
        if (error === GiftBoxEvents.WasGiftCancelled) {
          notificationMessage = 'キャンセルされています'
        } else if (error === GiftBoxEvents.WasGiftReceived) {
          notificationMessage = '既に受け取られています'
        }

        commit(
          types.RECEIVE_GIFT,
          {
            succeeded: false,
            notificationMessage: notificationMessage
          })
        commit(types.IN_PROGRESS, { inProgress: false })
      })
  },

  sendGift ({ commit }, payload) {
    commit(types.IN_PROGRESS, { inProgress: true })

    GiftService
      .send(payload.gift)
      .then(gift => {
        commit(types.SEND_GIFT, { gift: gift, succeeded: true })
        commit(types.IN_PROGRESS, { inProgress: false })
      })
      .catch(error => {
        var notificationMessage = '送信に失敗しました'
        if (error === GiftBoxEvents.IsGiftAlreadyExist) {
          notificationMessage = '既に送信されています'
        } else if (error === GiftBoxEvents.OnValueUnderCommission) {
          notificationMessage = '手数料よりも大きいEthereumを指定してください'
        }

        commit(
          types.SEND_GIFT,
          {
            succeeded: false,
            notificationMessage: notificationMessage
          })
        commit(types.IN_PROGRESS, { inProgress: false })
      })
  },

  cancelGift ({ commit }, payload) {
    commit(types.IN_PROGRESS, { inProgress: true })

    GiftService
      .cancel(payload.gift)
      .then(gift => {
        commit(types.CANCEL_GIFT, { succeeded: true })
        commit(types.IN_PROGRESS, { inProgress: false })
      })
      .catch(error => {
        commit(types.CANCEL_GIFT, { succeeded: false })
        commit(types.IN_PROGRESS, { inProgress: false })
      })
  },

  sendMail ({ commit }, payload) {
    commit(types.IN_PROGRESS, { inProgress: true })

    GiftService
      .sendMail(payload.gift, payload.mailAddress)
      .then(() => {
        commit(types.SEND_MAIL, { succeeded: true })
        commit(types.IN_PROGRESS, { inProgress: false })
      })
      .catch(error => {
        commit(types.SEND_MAIL, { succeeded: false })
        commit(types.IN_PROGRESS, { inProgress: false })
      })
  },

  changeProgressState({ commit }, payload) {
    commit(types.IN_PROGRESS, { inProgress: payload.inProgress })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/App.js